export default __webpack_public_path__ + "static/media/Screenshot (1174).02196ffe.png";